import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Same-page: smooth scroll to a hash target.
 * Cross-page: navigate to "/" + hash so ScrollToTop handles the scroll.
 */
export const useSmartScroll = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return useCallback(
    (hash) => {
      if (pathname === "/") {
        document.getElementById(hash.replace(/^#/, ""))?.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        navigate("/" + hash);
      }
    },
    [pathname, navigate],
  );
};
